<template>
    <div class="subtitle" :class="{ 'has-text-light': darkTheme }">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'Subtitle',
    computed: {
      darkTheme() {
        return this.$store.state.system.theme === 'dark';
      },
    },
}
</script>

<style scoped lang="scss">

</style>